import React, { useEffect } from 'react';
import { useAdmin } from '../context/AdminContext';
import { useAuth } from '../context/AuthContext';
import { accountsUsersUrl, shouldUseAccounts } from '../accounts';
import AdminTenantList from '../components/Admin/AdminTenantList';
import AdminTenantDetails from '../components/Admin/AdminTenantDetails';
import styles from './AdminPage.module.css';

const AdminPage: React.FC = () => {
  const { user, authConfig } = useAuth();
  const { error, hasAdminAccess } = useAdmin();
  const sso = shouldUseAccounts(authConfig);

  useEffect(() => {
    if (sso) {
      window.location.replace(accountsUsersUrl(authConfig.identity_url));
    }
  }, [sso, authConfig.identity_url]);

  if (sso) {
    return (
      <div className={styles['admin-page']}>
        <p>Redirecting to Accounts...</p>
      </div>
    );
  }

  // Check if user has admin access
  if (!user) {
    return (
      <div className={styles['admin-page']}>
        <div className={styles['admin-error']}>
          <h2>Access Denied</h2>
          <p>Please log in to access the admin panel.</p>
        </div>
      </div>
    );
  }

  if (!hasAdminAccess) {
    return (
      <div className={styles['admin-page']}>
        <div className={styles['admin-error']}>
          <h2>Admin Access Denied</h2>
          <p>Only Metrica users can access the admin panel.</p>
          <p>Current tenant: {user.tenant_id}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles['admin-page']}>
        <div className={styles['admin-error']}>
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles['admin-page']}>
      <div className={styles['admin-header']}>
        <h1>Admin Panel</h1>
        <p>Welcome, {user.name} ({user.email})</p>
      </div>
      
      <div className={styles['admin-content']}>
        <div className={styles['admin-sidebar']}>
          <AdminTenantList />
        </div>
        <div className={styles['admin-main']}>
          <AdminTenantDetails />
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
